import {Component, EventEmitter, Input, OnChanges, Output, SimpleChanges} from '@angular/core';
import {CommonModule} from '@angular/common';
import {VehicleBrand} from '../../../../domain/core/vehicle-brand.model';
import {CustomerClientResponse, Dealer, DealerWithGroup} from '../../../../domain/data/customer-client-response.data';
import {CustomerClientRequest} from '../../../../domain/data/customer-client-request.data';
import {CountryCodeHelper} from '../../../../shared/utils/CountryCodeHelper';

@Component({
    selector: 'app-group-dealer',
    templateUrl: './group-dealer.component.html',
    imports: [CommonModule]
})
export class GroupDealerComponent implements OnChanges {
  @Input() customerConsentRequest: CustomerClientRequest;
  @Input() customerConsentResponse: CustomerClientResponse;
  @Input() editMode = false;
  @Input() brand: VehicleBrand
  @Output() didChange = new EventEmitter<void>();

  selectedDealers: boolean[] = [];
  previousPreferredDealer: Dealer | null = null;
  previousPreferredDealerLexus: Dealer | null = null;
  latestDealerNumber?: string;

  protected readonly CountryCodeHelper = CountryCodeHelper;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['api']) {
      this.initializeSelection();
    }
  }

  initializeSelection() {
    if (this.customerConsentRequest && this.customerConsentRequest.groupDealerList) {
      this.selectedDealers = this.customerConsentRequest.groupDealerList.map(() => true);
    }
  }

  removeDealer(index: number, groupDealer: Dealer) {
    // toyota preferred dealer handling
    if (
      this.customerConsentRequest.preferredDealer &&
      this.customerConsentRequest.preferredDealer.dealerGroup === groupDealer.dealerNumber
    ) {
      this.previousPreferredDealer = this.customerConsentRequest.preferredDealer;
      this.customerConsentRequest.preferredDealer = null;
    } else if (
      this.customerConsentRequest.preferredDealer &&
      this.customerConsentResponse.preferredDealer.dealerGroup !== groupDealer.dealerNumber &&
      this.customerConsentRequest.preferredDealer.dealerGroup !== this.customerConsentResponse.preferredDealer.dealerGroup &&
      this.latestDealerNumber === groupDealer.dealerNumber
    ) {
      this.previousPreferredDealer = this.customerConsentResponse.preferredDealer;
      this.customerConsentRequest.preferredDealer = null;
    }

    // lexus preferred dealer handling
    if (
      this.customerConsentRequest.preferredDealerLexus &&
      this.customerConsentRequest.preferredDealerLexus.dealerGroup === groupDealer.dealerNumber
    ) {
      this.previousPreferredDealerLexus = this.customerConsentRequest.preferredDealerLexus;
      this.customerConsentRequest.preferredDealerLexus = null;
    } else if (
      this.customerConsentRequest.preferredDealerLexus &&
      this.customerConsentResponse.preferredDealerLexus.dealerGroup !== groupDealer.dealerNumber &&
      this.customerConsentRequest.preferredDealerLexus.dealerGroup !== this.customerConsentResponse.preferredDealerLexus.dealerGroup &&
      this.latestDealerNumber === groupDealer.dealerNumber
    ) {
      this.previousPreferredDealerLexus = this.customerConsentResponse.preferredDealerLexus;
      this.customerConsentRequest.preferredDealerLexus = null;
    }

    // delete from group dealer list
    this.customerConsentRequest.groupDealerList.splice(index, 1);
    this.selectedDealers.splice(index, 1);

    // delete from connected dealer list
    this.customerConsentRequest.connectedDealerList = this.customerConsentRequest.connectedDealerList.filter(
      dealer => dealer.dealerGroup !== groupDealer.dealerGroup
    );

    this.didChange.emit();
  }

  onDealerAdded(dealerWithGroup: DealerWithGroup) {
    const dealer = Dealer.createDealerWithGroup(dealerWithGroup);

    if (!dealer.fullCompanyName) {
      dealer.fullCompanyName = dealer.name; // Ensure fullCompanyName is set if it is empty
    }
    this.customerConsentRequest.groupDealerList.push(dealer); // Ensure the dealer is added to the list with fullCompanyName
    this.selectedDealers.push(true); // Automatically select the newly added dealer
    this.didChange.emit();
    const latestDealer = this.customerConsentRequest.groupDealerList[this.customerConsentRequest.groupDealerList.length - 1];
    this.latestDealerNumber = latestDealer.dealerNumber;
    console.log(latestDealer);
  }
}
